import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroRota from '../../actions/rota-itinerario/adicionarFiltroRotaItinerario'
import removerFiltroRota from '../../actions/rota-itinerario/removerFiltroRotaItinerario'
import listarFiltrosRotaItinerario from '../../actions/rota-itinerario/listarFiltrosRotaItinerario'
import {
  FILTRO_CIDADE_DESTINO,
  FILTRO_CIDADE_ORIGEM,
  FILTRO_DELIMITACAO,
  FILTRO_NOME_FANTASIA,
  FILTRO_ROTA,
  FILTRO_DATA_PARTIDA,
  FILTRO_STATUS_ITINERARIO,
  FILTRO_TIPO_PRECO
} from '../../util/filtros'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import FiltroBuscaRotaItinerario from './FiltroBuscaDisponiveisInternet';
import FiltroChaveValor from '../comum/FiltroChaveValor';

export class FiltrosDisponiveisInternet extends Component {
  componentDidMount() {
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.props.listarFiltrosRotaItinerario()
    }
  }

  componentDidUpdate(prevProps) {
    if (alterouEmpresa(this.props, prevProps)) {
      this.props.listarFiltrosRotaItinerario()
    }
  }


  adicionarFiltro(filtro) {
    this.props.adicionarFiltroRota(filtro)
  }

  removerFiltro(filtro) {
    this.props.removerFiltroRota(filtro)
  }

  render() {
    if (!this.props.cidadesOrigem) {
      return <div>Carregando...</div>
    }

    const distinct = (value, index, self) => {
      return self.indexOf(value) === index;
    }

    return (
      <React.Fragment>
        <div className="conteudo">
          <FiltroBuscaRotaItinerario
            filtro={FILTRO_DATA_PARTIDA}
            opcoes={[new Date().getFullYear()]}
            isFiltroData={true}
          />
          <FiltroBuscaRotaItinerario
            filtro={FILTRO_STATUS_ITINERARIO}
            opcoes={['Ativo', 'Inativo']}
            isRadio={true}
          />
          <FiltroBuscaRotaItinerario
            filtro={FILTRO_DELIMITACAO}
            opcoes={this.props.delimitacoes}
          />
          <FiltroChaveValor
            filtro={FILTRO_NOME_FANTASIA}
            opcoes={this.props.empresas}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
          <FiltroChaveValor
            filtro={FILTRO_ROTA}
            opcoes={this.props.rotas}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
          <FiltroChaveValor
            filtro={FILTRO_CIDADE_ORIGEM}
            opcoes={this.props.cidadesOrigem.filter(distinct)}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
          <FiltroChaveValor
            filtro={FILTRO_CIDADE_DESTINO}
            opcoes={this.props.cidadesDestino}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
          <FiltroChaveValor
            filtro={FILTRO_TIPO_PRECO}
            opcoes={this.props.tipoPrecos}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
        </div>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = state => ({
  prefixos: state.filtrosRotasItinerario.prefixos,
  delimitacoes: state.filtrosRotasItinerario.delimitacoes,
  cidadesOrigem: state.filtrosRotasItinerario.cidadesOrigem,
  cidadesDestino: state.filtrosRotasItinerario.cidadesDestino,
  filtrosAdicionados: state.filtrosAdicionadosRotaItinerario,
  empresaSelecionada: state.empresaSelecionada,
  empresas: state.filtrosRotasItinerario.empresas,
  rotas: state.filtrosRotasItinerario.rota,
  tipoPrecos: state.filtrosRotasItinerario.tipoPrecos

})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroRota,
    removerFiltroRota,
    listarFiltrosRotaItinerario
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltrosDisponiveisInternet)
